export default function AirlineNews() {
  const newsArticles = [
    {
      title: 'New Direct Routes from London to Pakistan Announced',
      excerpt: 'Major airlines expand UK-Pakistan connectivity with new direct flights from London Heathrow and Manchester to Lahore and Islamabad.',
      date: 'January 10, 2025',
      category: 'Route Updates',
      image: 'https://public.readdy.ai/ai/img_res/0cfb630cd5e98e0127db58a71de1347d.jpg',
    },
    {
      title: 'Umrah Flight Deals for Ramadan 2025',
      excerpt: 'Special discounted fares announced for Ramadan Umrah packages with flexible dates and group booking options available now.',
      date: 'January 8, 2025',
      category: 'Special Offers',
      image: 'https://readdy.ai/api/search-image?query=Masjid%20al-Haram%20Kaaba%20Mecca%20night%20view%20illuminated%20Islamic%20architecture%20pilgrims%20photography%20high%20quality&width=600&height=400&seq=news-umrah-001&orientation=landscape',
    },
    {
      title: 'Business Class Deals to Middle East',
      excerpt: 'Save up to 40% on business class tickets to Dubai, Doha, and Abu Dhabi with our exclusive negotiated corporate fares.',
      date: 'January 5, 2025',
      category: 'Fare Updates',
      image: 'https://readdy.ai/api/search-image?query=luxury%20business%20class%20airplane%20cabin%20interior%20comfortable%20seats%20premium%20travel%20photography%20high%20quality&width=600&height=400&seq=news-business-001&orientation=landscape',
    },
    {
      title: 'Family Travel Tips for Long-Haul Flights',
      excerpt: 'Expert advice on making long-haul flights comfortable for families with children, including entertainment and meal planning tips.',
      date: 'January 3, 2025',
      category: 'Travel Tips',
      image: 'https://readdy.ai/api/search-image?query=happy%20family%20with%20children%20at%20airport%20terminal%20traveling%20together%20smiling%20luggage%20photography%20high%20quality&width=600&height=400&seq=news-family-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Latest Airline News & Travel Updates
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Stay informed with the latest airline news, route updates, and travel industry insights
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {newsArticles.map((article, index) => (
            <article
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#14B8A6] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                  <i className="ri-calendar-line"></i>
                  <span>{article.date}</span>
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-3 leading-tight group-hover:text-[#14B8A6] transition-colors">
                  {article.title}
                </h3>

                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  {article.excerpt}
                </p>

                <button className="text-[#14B8A6] font-semibold text-sm flex items-center gap-2 hover:gap-3 transition-all cursor-pointer whitespace-nowrap">
                  Read More
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/travel-guides')}
            className="bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#0F9688] transition-colors inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
          >
            View All Travel Guides
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
